// extracted by mini-css-extract-plugin
export default {"subtitle":"index_subtitle__yFyfD","label":"index_label__k-x8R","icon":"index_icon__opa2i"};